const DEF_MAX_LENGTH_OF_LINE = 32;

/**
 * hex output
 */
export class HexOutput {

  // private format: boolean;
  //
  // private spacing: boolean;
  //
  // private maxLengthOfLine: number = DEF_MAX_LENGTH_OF_LINE;

  constructor(
    /**
     * Is format
     */
    private enableFormat: boolean,
    /**
     * Enable spacing between byte
     */
    private spacing: boolean,
    /**
     * Max length of line
     */
    private maxLengthOfLine: number = DEF_MAX_LENGTH_OF_LINE,
  ) {
  }

  public static def(): HexOutput {
    return new HexOutput(false, false, DEF_MAX_LENGTH_OF_LINE)
  }

  public static simple(format: boolean = true): HexOutput {
    return new HexOutput(format, true, DEF_MAX_LENGTH_OF_LINE)
  }

  public static formatWithMaxLength(maxLengthOfLine: number): HexOutput {
    return new HexOutput(true, true, maxLengthOfLine)
  }

  /**
   * Format binary
   */
  public format(binary: Uint8Array): string {
    // const hex = toHex(binary);
    const hex = Array.from(binary, function(byte) {
      return ('0' + (byte & 0xFF).toString(16)).slice(-2);
    }).join('');
    if (!this.enableFormat) {
      return hex;
    }

    let fmted = '';
    const textLength = hex.length;
    let lineIndex = 0;
    for (let ix = 0; ix < textLength; ix++) {
      const seq = ix + 1;
      const v = hex[ix];
      fmted += v;

      if (seq % 2 == 0 && this.spacing) {
        if (seq < textLength) {
          if (lineIndex + 1 < this.maxLengthOfLine) {
            fmted += ' ';
          }
          lineIndex += 1;
        }
      }

      if (lineIndex >= this.maxLengthOfLine) {
        fmted += '\n';
        lineIndex = 0;
      }
    }
    return fmted
  }

}
